import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
// import ClosureDurableArticlesWidget from '../../../widgets/durableArticlesWidget/manageDurableArticles/ClosureDurableArticlesWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import AssetBookingManagementDetailWidgets from '../../../widgets/assetBookingManagementWidgets/AssetBookingManagementDetailWidgets'
import { getAssetBookingManagementDetail } from '../../../redux/actions/assetBookingManagement'

export default function AssetBookingManagementDetailOfficer() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const bookingInfo = sessionGetItemObj('bookingInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const id = bookingInfo.id ? bookingInfo.id : ''
      const _schema = await getAssetBookingManagementDetail(id)
      console.log('schema ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader
          header={schema.header}
          subHeader={schema?.subHeader || ''}
          isNotCallApi
          isShowGoButton
        />

        <AssetBookingManagementDetailWidgets schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  header: 'จัดการคำขอจองครุภัณฑ์',
  form: {
    inputForm: {
      header: 'จัดการคำขอจองครุภัณฑ์',
      reserveProject: {
        name: 'reserveProject',
        label: 'ขอจองไปใช้กับโครงการ',
        value: '',
      },
      note: {
        name: 'note',
        label: 'ระบุหมายเหตุอื่นๆ',
        value: '',
      },
      comments: [{ label: 'เจ้าหน้าที่พัสดุ', value: 'xxx' }],
      comment: {
        name: 'comment',
        label: 'ความเห็น',
        value: '',
      },
    },
    assets: {
      totalSize: 0,
      values: [
        {
          id: '1',
          assetCode: '11',
          assetName: '22',
          assetAmount: '33',
          assetModel: '44',
          assetBrand: '55',
          assetType: '66',
          assetImg: '77',
        },
      ],
    },
    button: {
      reserveDoc: 'พิมใบจอง',
      concelReserve: 'ยกเลิกการจอง',
      request: 'ขออนุมัติ',
      cancel: 'ยกเลิก',
    },
  },
}
